import { BlockContainer } from '@components';
import { styled } from '@mui/material';
import { ReactNode } from 'react';

export type AuthBlockWrapperProps = {};

const AuthBlockWrapper = styled('div')<AuthBlockWrapperProps>`
  width: -webkit-fill-available;
  max-width: 500px;
  margin: 32px auto;
`;

export const AuthBlockContainer = ({ children }: { children: ReactNode }) => (
  <BlockContainer>
    <AuthBlockWrapper>{children}</AuthBlockWrapper>
  </BlockContainer>
);
